import { Trans } from '@lingui/macro';
import { observer } from 'mobx-react-lite';
import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { dropdownMenu } from '../../routes';

const Main: FC = () => {

    return (
        <div className='row pt-3 m-3 justify-content-start d-flex'>
            {dropdownMenu.map(menuItem => {
                return (
                    <Link className="col-sm-3" to={menuItem.path}>
                        <div className="card border-light mb-3 site-card">
                            <div className="card-header site-card-header">
                                <h5 className="card-title text-light"><Trans>{menuItem.title}</Trans></h5>
                            </div>
                            <div className="card-body">
                                <p className="card-text text-light shadow-lg bg-dark rounded">Нужно здесь описать страницу</p>
                            </div>
                        </div>
                    </Link>
                    
                )
            })}
        </div>
    )
};
export default observer(Main);